import * as React from 'react';
import styled from "styled-components";
import nodataIcon from "../../Assets/nodata.svg";

function Nodata() {
  return <>
    <Main>
      <div>
      <img src={nodataIcon} alt="nodata"/>
      </div>
      <h3><b>Data Not Found</b></h3>
      </Main>
  </>
}
export default Nodata;
const Main = styled.div`
     min-height:calc(100vh - 103px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;